
import utils from '@/utils';
import Sortable from 'sortablejs';

import { Component, Vue ,Provide} from 'vue-property-decorator';

@Component
export default class ManageSalaries extends Vue {
  $store: any;
  $message: any;
  $refs: any;
       @Provide() daepickervalue?: any=""; // 时间范围 value
        @Provide() tabelHeight: number = window.innerHeight;
       
       @Provide() gridcorryupdate: any={ 教师id:'', 导师: '',时薪类型: '', 时薪: '', 人民币的额度:'', 付款方式:'', 账号信息:'', 账号姓名:"",操作:""};
       @Provide() gridData: any = [];   //追加
         
       @Provide() options: any = [];   //导师下拉框
       @Provide() gridsearch1: any ={ value: '',label: ''};
       @Provide() value = '';
       @Provide() queryInfo: any = {
                                    query:'',
                                    pageNum:1,//当前页
                                    pageSize:10  //当前每页显示多少条
                                  };
				@Provide() total?: number = 0;
        @Provide() ConfirmationTime?: number = 0;
        @Provide() Col1: any = [
          {
						label: "导师",
						prop: "teacherName",
						width: "150",
						isTrue: true
					},
					{
						label: "时薪类型",
						prop: "types",
						width: "120",
						isTrue: true
					},
					{
						label: "时薪",
						prop: "teacherRate",
						width: "110",
						isTrue: true
					},
					{
						label: "人民币的额度",
						prop: "salaryCNY",
						width: "130",
						isTrue: true
					},
					{
						label: "美元额度",
						prop: "salaryUSD",
						width: "130",
						isTrue: true
					},
					{
						label: "付款方式",
						prop: "teacherPay",
						width: "150",
						isTrue: true
					},
					{
						label: "账号信息",
						prop: "userInformation",
						width: "150",
						isTrue: true
					},
					{
						label: "账号姓名",
						prop: "userName",
						width: "150",
						isTrue: true
					},
					{
						label: "证件信息",
						prop: "identity",
						width: "250",
						isTrue: true
					},
					{
						label: "签约电话",
						prop: "phone",
						width: "200",
						isTrue: true
					},
					{
						label: "微信授权名",
						prop: "nickName",
						width: "200",
						isTrue: true
					}
				];
         @Provide() dropCol: any = [
          {
						label: "导师",
						prop: "teacherName",
						width: "150",
						isTrue: true
					},
					{
						label: "时薪类型",
						prop: "types",
						width: "120",
						isTrue: true
					},
					{
						label: "时薪",
						prop: "teacherRate",
						width: "110",
						isTrue: true
					},
					{
						label: "人民币的额度",
						prop: "salaryCNY",
						width: "130",
						isTrue: true
					},
					{
						label: "美元额度",
						prop: "salaryUSD",
						width: "130",
						isTrue: true
					},
					{
						label: "付款方式",
						prop: "teacherPay",
						width: "150",
						isTrue: true
					},
					{
						label: "账号信息",
						prop: "userInformation",
						width: "150",
						isTrue: true
					},
					{
						label: "账号姓名",
						prop: "userName",
						width: "150",
						isTrue: true
					},
					{
						label: "证件信息",
						prop: "identity",
						width: "250",
						isTrue: true
					},
					{
						label: "签约电话",
						prop: "phone",
						width: "200",
						isTrue: true
					},
					{
						label: "微信授权名",
						prop: "nickName",
						width: "200",
						isTrue: true
					}
				];
				
				
				
		@Provide() ifUpd: any = false;
		@Provide() wxTeacherId: any = null;
		@Provide() wxTeachers: any = [];
        @Provide() sortable: any = "";
        @Provide() StringOrderBy: any = "1";
        @Provide() dialogVisible: any = false;    //弹窗标签
        @Provide() ruleForm: any = { //课节信息编辑form表单
                    TeacherManage: '',
                    TeacherClassName: '',
                    TeacherRate: '',
                    selects: '',
                    UManageInfo: '',
                    UManageName: '',
                    rateType: '美元',
					identity:'',
					phone:'',
        };
        @Provide() rules: any = {      //验证
                    TeacherManage: [
                        { required: false, message: '请输入教师id', trigger: 'blur' },
                    ],
                    TeacherClassName: [
                        { required: false, message: '请选择教师姓名', trigger: 'blur' }
                    ],
                    TeacherRate: [
                        { required: true, message: '请输入时薪', trigger: 'blur' },
                    ],
                    selects: [
                        { required: true, message: '请选择付款方式', trigger: 'blur' },
                    ],
                    UManageInfo: [
                        { required: true, message: '请输入信息', trigger: 'blur' },
                    ],
                    UManageName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    rateType: [
                        { required: true, message: '请选择时薪类型', trigger: 'blur' },
                    ]
                };


    /**
      * @description: 导师信息中的列拖拽方法
      * @return void
      */
      columnDrop(): void {
				const wrapperTr: any = document.querySelector('.el-table__header-wrapper tr');
				this.sortable = Sortable.create(wrapperTr, {
					animation: 180,
					delay: 0,
					onEnd: (evt: any) => {
						const oldItem = this.dropCol[evt.oldIndex];
						this.dropCol.splice(evt.oldIndex, 1);
						this.dropCol.splice(evt.newIndex, 0, oldItem);
					}
				});
			}

    /**
      * @description: 提交导师修改信息
      * @return void
      */
      submitForm(formName: any): void {
		  
          this.$refs[formName].validate((valid: any) => {
                    if (valid) {
                        const TeacherID = parseInt(this.ruleForm.TeacherManage);    //Teacherid
                        const TeacherName = (String)(this.ruleForm.TeacherClassName);
                        const rateLeng = parseInt(this.ruleForm.TeacherRate);
                        const TeacherSelects = (String)(this.ruleForm.selects);
                        const userName = (String)(this.ruleForm.UManageName);
                        const UManageinfo = (String)(this.ruleForm.UManageInfo);
                        let type = (String)(this.ruleForm.rateType)=== "美元"?"USD":"CNY";
						// if(this.ruleForm.ifUpd == true || this.ruleForm.wxTeacherId == null){
						// 	this.$message({
						// 		message: '请选择微信教师信息',
						// 		type: "info",
						// 		duration: 2000
						// 	});
						// 	return;
						// }
                        utils.requestPost("更改教师基本信息",
                            "sale/updAllMessages", { "teacherId": TeacherID, "teacherName": TeacherName, "teacherRate": rateLeng, "teacherSelect": TeacherSelects, "userName": userName, "userInformation": UManageinfo, "types": type,"identity":this.ruleForm.identity,"phone":this.ruleForm.phone,"wxTeacherId":this.wxTeacherId }
                        ).then((data: any) => {
                            if (data > 0) {
                                  this.$message({
                                  showClose: true,
                                  message: '修改成功！',
                                  type: 'success'
                                });
                            }
                            else
                            this.$message({
                                  showClose: true,
                                  message: '修改失败！',
                                  type: 'error'
                                });
                            this.loaddata();
                        })

                        //关闭修改导师弹窗
                        this.dialogVisible = false;
                    } else {
                        return false;
                    }
                });
      }
      
      /**
        * @description: 修改导师基本信息 "重置" 按钮触发事件
        * @param {any} formName
        * @return void
        */
      resetForm(formName: any): void {
         this.$refs[formName].resetFields();
      }

      /**
        * @description: 关闭修改导师信息弹窗
        * @return void
        */
      handleClose(): void {
          this.dialogVisible = false;
      }

      /**
        * @description: 将导师信息赋值到修改导师弹窗中
        * @return void
        */
      managementteacherchange(e: any): void {
                this.dialogVisible = true;
                this.ruleForm.TeacherManage = e.id;
                this.ruleForm.TeacherClassName = e.teacherName;
                this.ruleForm.rateType = e.types=="CNY"?"人民币":"美元";   //修改美元或人民币的类型
                this.ruleForm.UManageName = e.userName;
                this.ruleForm.selects = e.teacherPay;
                this.ruleForm.UManageInfo = e.userInformation;
                this.ruleForm.TeacherRate = e.teacherRate;
				this.ruleForm.identity = e.identity;
				this.ruleForm.phone = e.phone;
				this.ruleForm.nickName = e.nickName;
				this.wxTeacherId = null;
				if(e.nickName == "" ){
					this.ifUpd = true;
				}else{
					this.ifUpd = false;
				}
      }
	  
	  changeWxTeacher(){
		  this.ifUpd = true;
	  }

      /**
        * @description: 导师筛选查询触发事件
        * @param {any} e
        * @return void
        */
      searchTeacherOption(): void{
        this.queryInfo.pageNum=1;
        this.loaddata();//渲染数据
      }

    /**
      * @description: 导师信息中自定义排序方法
      * @param {any} column 导师信息中的列信息
      * @param {any} key 
      * @param {any} order (升序/排序)
      * @return void
      */
      sortChange(column: any, key: any, order: any): void {    //排序切换
					//获取字段名称和排序类型
					const fieldName = column.prop;
					const sortingType = column.order;
					const StringName = this.switchfield(fieldName);//对于table column的fieldName进行处理后返回
					this.StringOrderBy = "";
          /**
           * 当sortingType为"ascending"时，stringOrderBy将拼接成数据库执行语句 ASC
           * 当sortingType为"descending"时，stringOrderBy将拼接成数据库执行语句 DESC
           * 当sortingType为空时，order by 将根据 学生id排序 DESC
           */
					if(sortingType==="ascending"){
						this.StringOrderBy=StringName+" ASC";//升序
					}else if(sortingType==="descending")
					{
						this.StringOrderBy=StringName+" DESC";//降序
					}
					else
					{
						this.StringOrderBy=1+" asc";  //默认不排序，但需重新查询
					}
					this.loaddata();//渲染导师基本信息
			}

      /**
        * @description: 在导师信息中 对于table column的fieldName进行对应过滤 order by 字段排序
        * @param {string} name
        * @return void
        */
      switchfield(name: any): number{
          switch(name) {
          case "teacherName":
            return 2;	
          case "types":
            return 3;	
          case "teacherRate":
            return 4;	
          case "salaryCNY":
            return 5;	
          case "salaryUSD":
            return 6;
          case "teacherPay":
            return 7;
          case "userInformation":
            return 7;
          case "userName":
            return 8;
          case "id":
            return 1;
          default:
            return 1;
          } 
			}

    /**
      * @description: 分页功能中 当尺寸改变时触发该方法
      * @param {any} val
      * @return void
      */
      handleSizeChange(val: any): void {
          this.queryInfo.pageSize = val;    //监听page改变的页数
          this.loaddata();
        	if(this.ConfirmationTime==2){
              this.manageclickdata();
            }
            else
              this.loaddata();
			}

    /**
      * @description: 分页功能中 当"当前页"改变时触发该方法
      * @param {any} val
      * @return void
      */
			handleCurrentChange(val: any): void {
				this.queryInfo.pageNum = val;     //监听页面值改变的事件
        this.loaddata();
        if(this.ConfirmationTime==2){
					this.manageclickdata();
				}
				else
					this.loaddata();
			}

      /**
        * @description: 查询总薪水信息
        * @return void
        */
      loadTotal(): void{
          utils.requestPost("查询总薪水",
            "sale/selectTotal", null
          ).then((data: any) => {
            this.total=(Number)(data);
          });
      }

      /**
        * @description: 根据时间范围进行查询老师薪水总条数
        * @return void
        */
      loadTimeTotal(): void{
         utils.requestPost("根据时间范围进行查询老师薪水信息",
                    "sale/searchSelectTimeTotal", {
                      "searchselectdate":{
														"class_StartName":this.daepickervalue[0],
														"class_EndName":this.daepickervalue[1]
													},
											"page":{
														"pageNum": 1,
														"pageSize": 10
													}
                    }
                  ).then((data: any) => {
                    this.total=(Number)(data);
                  });
      }

      /**
        * @description: 查询老师基本信息
        * @return void
        */
      searchteacher(): void{
         utils.requestGet("查询老师基本信息",
                    "teacher/select", null
                  ).then((data: any) => {
                      let option=[];
                      for(let i=0;i<data.length;i++){
                          option.push(data[i].teacherName);
                      }
                      this.options=option;
                  });
      }

      /**
        * @description: 查询导师基本信息并返回总条数
        * @return void
        */
      loaddata(): void{
              let total: any;
              let gridData: any;
                utils.requestPost("查询老师总条数",
                  "sale/select", {
                                  "searchSelectDate":{
                                              "classStartName":"", 
                                              "classEndName":""
                                            },
                                  "page":{
                                        "pageNum": this.queryInfo.pageNum,
                                        "pageSize": this.queryInfo.pageSize,
                                        "switchDate":false 	
                                      },
                                  "stringOrderBy":this.StringOrderBy,
                                  "teacherName":this.value,
                                  "courseName":"",
                                  "headmaster":"",
                                }
                ).then((data: any) => {
                  if(data.total>0)
                    this.total=Number(data.total);     //查询总条数
                  else
                    this.total=0;
                    this.gridData = data.data;
                })         
      }

      /**
        * @description: 根据时间范围查询老师基本信息
        * @return void
        */
      manageclickdata(): void{
        if(this.daepickervalue){
            this.ConfirmationTime=2;
            this.loadTimeTotal();
						utils.requestPost("根据时间范围查询老师基本信息",
							"sale/searchSelectTime", {
							        "searchselectdate":{
														"class_StartName":this.daepickervalue[0],
														"class_EndName": this.daepickervalue[1]
													},
											"page":{
														"pageNum": this.queryInfo.pageNum,
														"pageSize": this.queryInfo.pageSize
													}
							}
						).then((data: any) => {
                      this.gridData=[];
                      this.options=[];
                      for(let i in data){
                          this.gridsearch1 = { value: '',label: ''};
                          this.gridcorryupdate = { 教师id:'', 导师: '', 时薪: '', 付款方式:'', 人民币的额度:'', 账号信息:'', 账号姓名:"",操作:""};
                          this.gridcorryupdate.导师=data[i].tid.teacher_Name;
                          this.gridsearch1.label = data[i].tid.teacher_Name;
                          this.gridcorryupdate.教师id=data[i].tid.id;
                          this.gridsearch1.value=(String)(data[i].tid.id) ;
                            if(data[i].tid.types=="CNY"){        //   时薪类型  格式转换
                              this.gridcorryupdate.时薪类型="人民币";
                            }
                            else this.gridcorryupdate.时薪类型="美元";
                                
                          this.gridcorryupdate.时薪= data[i].tid.teacher_Rate;
                          this.gridcorryupdate.付款方式= data[i].tid.teacher_Pay;
                          this.gridcorryupdate.人民币的额度= "";
                          this.gridcorryupdate.账号信息= data[i].tid.user_Information;
                          this.gridcorryupdate.账号姓名= data[i].tid.user_Name;
                         
                            this.options=this.options.concat(this.gridsearch1);
                            this.gridData=this.gridData.concat(this.gridcorryupdate);
                     
                      }
            })
           
        }
         else {
                  this.ConfirmationTime=1;
                  utils.requestGet("查找老师基本薪水信息",
                    "sale/select", null
                  ).then((data: any) => {
                      this.gridData=[];
                      this.options=[];
                      for(let i in data){
                          this.gridsearch1 = { value: '',label: ''};
                          this.gridcorryupdate = { 教师id:'', 导师: '', 时薪: '', 付款方式:'', 人民币的额度:'', 账号信息:'', 账号姓名:"",操作:""};
                          this.gridcorryupdate.导师=data[i].teacher_Name;
                          this.gridsearch1.label = data[i].teacher_Name;
                          this.gridcorryupdate.教师id=data[i].id;
                          this.gridsearch1.value=(String)(data[i].id) ;
                          if(data[i].types=="CNY"){        //   时薪类型  格式转换
                              this.gridcorryupdate.时薪类型="人民币";
                          }
                            else this.gridcorryupdate.时薪类型="美元";
                                
                          this.gridcorryupdate.时薪= data[i].teacher_Rate;
                          this.gridcorryupdate.付款方式= data[i].teacher_Pay;
                          this.gridcorryupdate.人民币的额度= "";
                          this.gridcorryupdate.账号信息= data[i].user_Information;
                          this.gridcorryupdate.账号姓名= data[i].user_Name;
                          let  flag=true;

                      for(let i=0;i<this.options.length;i++){
                        if(this.options[i].value==this.gridsearch1.value){
                          flag=false;
                        }
                      }
                      if(flag)
                        {
                            this.options=this.options.concat(this.gridsearch1);
                            this.gridData=this.gridData.concat(this.gridcorryupdate);
                        }
                      }
                  })
              
        }
      }    
/**
  * @description: 生命周期 created实例创建完成
  * @return void
  */
    created(){
      this.$store.commit('loadingInformation',0)
      this.loaddata();          //渲染数据
      this.searchteacher();     //下拉选择菜单
	  utils.requestGet("查询微信教师信息",
	             "teacher/selectWxTeacher", null
	           ).then((data: any) => {
	              this.wxTeachers = data;
	           });
    }

/**
  * @description: 生命周期 mounted挂载后
  * @return void
  */
   mounted(){
     window.onresize = ()=>{this.tabelHeight = window.innerHeight;};
      this.columnDrop();   // 表列拖拽
   }
}
